import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FunctionsCatalogFilterCard = _resolveComponent("FunctionsCatalogFilterCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
      return (_openBlock(), _createBlock(_component_FunctionsCatalogFilterCard, {
        class: "kn-flex p-m-2",
        key: filter.valueId,
        propFilter: filter,
        onSelected: _ctx.onSelected
      }, null, 8, ["propFilter", "onSelected"]))
    }), 128))
  ]))
}